import { render, staticRenderFns } from "./UsersListPage.vue?vue&type=template&id=73056299&scoped=true&"
import script from "./UsersListPage.vue?vue&type=script&lang=js&"
export * from "./UsersListPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersListPage.vue?vue&type=style&index=0&id=73056299&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73056299",
  null
  
)

export default component.exports